import { ProviderUserType } from '../../../enums/providerUserType';

export class ProviderUserUpdateRequest {
    type: ProviderUserType;
}
